import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Membership {
  tenantId: string;
  tenantName: string;
  role: string;
}

export interface CurrentUser {
  id: string;
  email: string;
  name: string;
  isPlatformAdmin?: boolean;
  memberships: Membership[];
}

interface AuthState {
  accessToken: string | null;
  user: CurrentUser | null;
  setAccessToken: (t: string | null) => void;
  setUser: (u: CurrentUser | null) => void;
  clear: () => void;
}

/**
 * Auth del operador (cross-tenant): SIN `activeTenantId` ni selector de tenant.
 * El access token vive en memoria; el refresh cookie re-autentica.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setAccessToken: (accessToken) => set({ accessToken }),
      setUser: (user) => set({ user }),
      clear: () => set({ accessToken: null, user: null }),
    }),
    { name: 'cajita-admin-auth', partialize: () => ({}) },
  ),
);
